"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = detail;

var _DetailActions = require("./DetailActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Implicitní funkce pro načtení data key.
 * @returns {*|null|number|string}
 */
function getDataKey() {
    var dataKey = "";

    // Filter
    dataKey += (0, _stringify2.default)(this.filter);

    // Parent id
    dataKey += "_" + this.id;

    // ---

    return dataKey;
}

var initialState = {
    data: null,
    id: null,
    isFetching: false,
    fetched: false,
    currentDataKey: "",
    filter: {}, // pokud je detai zobrazován na základě filtru
    getDataKey: getDataKey,
    reducer: detail
};

function detail() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    // Konfigurace
    if (config) {
        state = (0, _extends3.default)({}, state);

        if (config.filter) {
            // inicializační filtr
            state.filter = config.filter;
        }
    }

    switch (action.type) {
        case _DetailActions.REQUEST:
            return (0, _extends3.default)({}, state, {
                isFetching: true,
                currentDataKey: action.dataKey
            });
        case _DetailActions.RESPONSE:
            {
                return (0, _extends3.default)({}, state, {
                    isFetching: false,
                    fetched: true,
                    data: action.data
                });
            }
        case _DetailActions.FILTER:
            {
                return (0, _extends3.default)({}, state, {
                    filter: action.filter
                });
            }
        case _DetailActions.SELECT:
            {
                return (0, _extends3.default)({}, state, {
                    id: action.id,
                    data: state.id === action.id ? state.data : null,
                    fetched: state.id === action.id ? state.fetched : false
                });
            }
        case _DetailActions.INVALIDATE:
            {
                if (action.id === state.id) {
                    return (0, _extends3.default)({}, state, {
                        currentDataKey: initialState.currentDataKey
                    });
                } else {
                    return state;
                }
            }
        case _DetailActions.UPDATE_VALUE:
            {
                return (0, _extends3.default)({}, state, {
                    data: action.data
                });
            }
        case _DetailActions.RESET:
            {
                return (0, _extends3.default)({}, initialState, {
                    filter: config && config.filter ? config.filter : initialState.filter
                });
            }
        default:
            return state;
    }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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